import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  allowedTracingOrigins: [process.env.PLATFORM_API_BASEURL ?? 'fake'],
  applicationId: process.env.DATADOG_APPLICATION_ID ?? 'fake',
  clientToken: process.env.DATADOG_CLIENT_TOKEN ?? 'fake',
  defaultPrivacyLevel: 'mask-user-input',
  env: process.env.DATADOG_ENV,
  sampleRate: parseInt(process.env.DATADOG_SAMPLE_RATE || '0', 10),
  service: 'docupload',
  site: 'us3.datadoghq.com',
  trackInteractions: true,
});

datadogRum.startSessionReplayRecording();
